<template>
    <div class="menuNav">
        <div class="menu_top"></div>

        <el-menu
            class="el-menu-vertical-demo"
            text-color="#fff"
            :default-active="activeindex"
            active-text-color="#dd4f50">

            <el-menu-item index="1" class="home" @click="$router.push({ name: 'index' });">
                <i class="iconfont menuicona"></i>
                <span slot="title">系统首页</span>
            </el-menu-item>

            <el-submenu v-for="menu in menuList" :index="menu.index" :key="menu.index">
                <template slot="title">
                    <i :class="'iconfont menuicon'+menu.icon"></i>
                    <span>{{menu.title}}</span>
                </template>
                <!-- sub children -->
                <template v-for="sub in menu.children">
                    <template v-if="sub.condition">
                        <el-menu-item :index="sub.index" @click="$router.push({name: sub.name, params: sub.params});" v-if="condition(sub.condition)">
                            <span>• {{sub.title}}</span>
                        </el-menu-item>
                    </template>
                    <template v-else>
                        <el-menu-item :index="sub.index" @click="$router.push({name: sub.name, params: sub.params});">
                            <span>• {{sub.title}}</span>
                        </el-menu-item>
                    </template>
                </template>
            </el-submenu>
        </el-menu>

       <!-- <div class="menu_foot">

        </div>-->

    </div>
</template>
<style >
    i.iconfont {
        width: 18px;
        display: inline-block;
        height: 18px;
    }
    .menuicona{
        background-image: url(~@/assets/images/menu/a.png);
        width: 16px!important;
        height: 16px!important;
    }.menuicon1{
        background-image: url(~@/assets/images/menu/1.png)
    }.menuicon2{
        background-image: url(~@/assets/images/menu/2.png)
    }.menuicon3{
        background-image: url(~@/assets/images/menu/3.png)
    }.menuicon4{
        background-image: url(~@/assets/images/menu/4.png)
    }.menuicon5{
        background-image: url(~@/assets/images/menu/5.png)
    }.menuicon6{
        background-image: url(~@/assets/images/menu/6.png)
    }
    .el-submenu__title {
        background-color: #273B5A!important;
        border-bottom: 1px solid #3c5175;
        color: #99B8EE!important;
    }.el-submenu.is-active .el-submenu__title {
         border-bottom-color:#3c5175;
     }
</style>
<script>
    export default {
        name: "menuNav",
        data () {
            return {
                submenu: false, //发布房源子菜单
                activeindex:'',
                userInfo:[],
                list:[],
                menukey:[
//                                '1|index|',
                '2-1|myServiceHa|searchHa|',
                '2-2|analysis|',
                '2-3|posterIndex|posterEdit|posterManage|',
                '3-1|houseManage|editRelease|releaseImage|',
                '3-2|release|reissue|',
                '4-1|comInfo|',
                '4-2|myInfo|',
                '4-3|accountBinding|',
                '4-4|staffList|',
                '5-1|wechatAccount|',
                '5-2|selfMenu|',
                '5-3|messaging|',
                '6-0|openWyfee|openWyfee1|openWyfee2|openWyfee3',
                '6-1|houseList|',
                '6-2|orderList|',
                '6-3|arrearsList|',
                '7-1|repairList|',
            ]
            }
        },
        mounted() {
            this.userInfo=this.$store.getters.getUserInfo();
            this.getList();
        },
        computed:{
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            menuList() {
                let menuList = this.$store.getters.menuList;
                // 管理员显示所有菜单
                if (this.isAdmin) {
                    return menuList;
                }
                // 获取用户设置的菜单列表
                let userMenu = this.$store.getters.userMenu;
                // 最终用户需要显示的菜单
                let finalMenu = [];
                for(let menu of menuList) {
                    let hasMenu = {...menu};
                    hasMenu.children = menu.children.filter(sub => sub.forever || userMenu.includes(sub.index));
                    if (hasMenu.children.length) {
                        finalMenu.push(hasMenu);
                    }
                }
                return finalMenu;
            },
            showSelfMenu(){
                let show=false;
                if(this.list.length){
                    this.list.forEach(function(item){
                        if(`,${item.funcInfo},`.includes(',15,')){
                            show=true;
                        }
                    })
                }
                return show;
            },
            showMessage(){
                let show=false;
                if(this.list.length){
                    this.list.forEach(function(item){
                        if(`,${item.funcInfo},`.includes(',7,')){
                            show=true;
                        }
                    })
                }
                return show;
            },
        },
        methods: {
            logoutsys: function () {
                var that = this;
                this.logout().then(() => {
                    that.$router.push({name: "login"})
                })
            },
            //获取权限
            getList() {
                this.axios.get('/api/offiaccount/auth-list', {
                        params: {}
                }).then(({status,data}) => {
                    if(data.status=='200'){
                        this.list=data.data;
                    }
                });
            },
            condition(key) {
                return this[key];
            }

    },
    watch: {
        $route(to, from) {
            var that = this;
            that.activeindex = '';
            if (to.name == 'addHaInfo') {
                if (from.name == 'analysis') {
                    that.activeindex = '2-2';
                } else {
                    that.activeindex = '2-1';
                }
            } else {
                this.menukey.forEach(function (item) {
                    if (item.indexOf(to.name) >= 0) {
                        that.activeindex = item.split('|')[0];
                    }
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/menuNav.vue